import { api } from "./client";
import type { ApiResponse } from "./types";

export type ThreadStatus = "open" | "recap" | "closed";
export type ThreadMessageKind = "chat" | "recap" | "nudge";

export interface EventThread {
  id: string;
  eventId: string;
  status: ThreadStatus;
  recapAt: string | null;
  closedAt: string | null;
  createdAt: string;
}

export interface ThreadMessage {
  id: string;
  kind: ThreadMessageKind;
  body: string;
  /** null for system-seeded nudge messages */
  user: { id: string; name: string; avatarUrl: string | null } | null;
  isOwn: boolean;
  createdAt: string;
}

export interface ThreadMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export function getThread(eventId: string) {
  return api.get<
    ApiResponse<{
      thread: EventThread;
      unreadCount: number;
      lastReadAt: string | null;
    }>
  >(`/events/${eventId}/thread`);
}

export function listThreadMessages(eventId: string, page = 1, limit = 50) {
  return api.get<
    ApiResponse<{ messages: ThreadMessage[]; meta: ThreadMeta }>
  >(`/events/${eventId}/thread/messages?page=${page}&limit=${limit}`);
}

/** One `idempotencyKey` per send; resending with the same key must return the same message. */
export function postThreadMessage(eventId: string, body: string, idempotencyKey?: string) {
  return api.post<ApiResponse<ThreadMessage>>(
    `/events/${eventId}/thread/messages`,
    { body, ...(idempotencyKey ? { idempotencyKey } : {}) },
  );
}

export function deleteThreadMessage(eventId: string, messageId: string) {
  return api.delete<void>(`/events/${eventId}/thread/messages/${messageId}`);
}

export function markThreadRead(eventId: string) {
  return api.post<ApiResponse<{ read: true; lastReadAt: string }>>(
    `/events/${eventId}/thread/read`,
  );
}
